export default [
  {
    path: '',
    name: 'CRMAdmin.ContactTypes',
    component: () => import('../views/Types')
  }
]



// WEBPACK FOOTER //
// ./src/apps/crm/admin/routes/index.js